export default "__VITE_ASSET__TMRFGDXg__"